import { defineComponent, inject, provide, type SlotsType } from 'vue'

type Listeners<T = Any> = (payload: T) => void

interface EventBus {
  emit<T = Any>(event: string, payload?: T): void
  on<T = Any>(event: string, listeners: Listeners<T>): () => void
}

const CTX_SCOPE_NAME = 'CTX_SCOPE_NAME'

const createEventBus = (): EventBus => {
  const listeners: Map<string, Set<Listeners>> = new Map()

  return {
    on: (event, listener) => {
      if (!listeners.has(event)) {
        listeners.set(event, new Set())
      }

      listeners.get(event)!.add(listener)

      return () => {}
    },

    emit: (event, payload) => {
      const set = listeners.get(event)

      if (set) {
        ;[...set].forEach((listener) => listener(payload))
      }
    },
  }
}

const ContextServiceProvider = defineComponent({
  name: 'ContextServiceProvider',

  slots: Object as SlotsType<{
    default: () => Any
  }>,

  setup(_, { slots }) {
    const eventBus = createEventBus()

    provide(CTX_SCOPE_NAME, eventBus)

    return () => slots.default()
  },
})

export const useContextServiceInject = () => {
  const bus = inject<EventBus>(CTX_SCOPE_NAME)

  if (!bus) {
    throw new Error(`useContextService() 必须在 <ContextServiceContainer /> 组件内部使用!`)
  }

  return bus
}

export default ContextServiceProvider
